export default "__VITE_ASSET__BruKyAq7__"